import React from "react";
import { HiSparkles } from "react-icons/hi2";

const APP_INSTALL_URL = "https://www.1472.ai/app-install";
const APP_QR_SRC = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(
  APP_INSTALL_URL
)}`;

const MonotiQrGuideBubble = () => {
  return (
    <div className="monotiQrBubble">
      <div className="monotiQrThumb">
        <img src={APP_QR_SRC} alt="모노티 앱 설치 QR 코드" />
      </div>

      <div className="monotiQrCopy">
        <div className="monotiQrBadge">
          <span className="icon" aria-hidden="true">
            <HiSparkles />
          </span>
          <span>MONOTI APP</span>
        </div>

        <div className="monotiQrTitle">
          모노티 앱을 사용하면 보관함을 더 편하게 열고 닫을 수 있어요.
        </div>

        <div className="monotiQrDesc">QR을 찍고 앱에서 바로 이용해보세요</div>
      </div>
    </div>
  );
};

export default MonotiQrGuideBubble;
